module.exports = __webpack_public_path__ + "img/Rickard Klab.3933c6e4.png";